export const Categories = [
  {
    id: 1,
    title: "SECTION",
    category: "Section",
  },
  {
    id: 2,
    title: "BEST",
    category: "Best",
  },
  {
    id: 3,
    title: "NEW",
    category: "New",
  },
  {
    id: 4,
    title: "BONUS",
    category: "Bonus",
  },
  {
    id: 5,
    title: "OTHER",
    category: "Other",
  },
];
